import { useGetSpectrumQuery } from "../spectraSlice";

const useGetSpectrum = ({ id }) => {
  const spectrum = useGetSpectrumQuery({ id }, { skip: id == null });

  return spectrum;
};

export default useGetSpectrum;
